<script setup lang="ts">
    // Red validation banner shown above an image drop zone when files break the constraints
    // (spec §4.2 / §4.6). Presentational only: the title + lines are pre-formatted by
    // `useImageValidation` (single-file wording for Logo/Cover, per-file lines for the Portfolio batch).
    defineProps<{
        title: string;
        lines: string[];
    }>();
</script>

<template>
    <div class="flex items-start gap-3 rounded-lg border border-branding-red/30 bg-branding-red-light px-4 py-3 font-inter">
        <i class="fa-solid fa-triangle-exclamation mt-0.5 text-base text-branding-red"></i>
        <div class="flex flex-col gap-0.5">
            <p class="text-sm font-semibold text-branding-red">
                {{ title }}
            </p>
            <p
                v-for="(line, index) in lines"
                :key="index"
                class="text-sm text-branding-red/90"
            >
                {{ line }}
            </p>
        </div>
    </div>
</template>
